// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_Nca","cls2":"Configuration-cls2__g5 Configuration-cls1_Nca","success":"Configuration-success_5Qy","error":"Configuration-error_T6y"};